import type { AxiosError, AxiosResponse } from 'axios'
import type { IAxiosRetryConfig } from 'axios-retry'

interface ServiceUrlBase {
  url: string
  isInternal: boolean
}

export type ServiceUrlBases = Record<string, ServiceUrlBase>
export interface ApiConfig {
  internalHeaders: Record<string, string>
}

export enum HTTP_METHOD {
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface CallOptions {
  method: HTTP_METHOD
  url: string
  baseURL?: string
  // TODO have serviceName as an enum. This enum would be defined on the end client and pass it to CallOptions as a generic
  serviceName?: string
  headers?: Record<string, string>
  payload?: any
}

export interface RTKCustomError {
  error: { status: number; data: any }
}
export type ConfigGenerator = () => ApiConfig

export interface ApiConstructorParams {
  serviceUrlBases: ServiceUrlBases
  configGenerator: ConfigGenerator
  axiosRetry?: {
    disabled?: boolean
    config?: IAxiosRetryConfig
  }
  axiosInterceptorsCallback?: {
    response?: {
      onFulfilled?: <T = AxiosResponse>(value: AxiosResponse) => T | Promise<T>
      onRejected?: (error: AxiosError) => any
    }
    request?: {
      beforeSend?: (<V = any>(value: V) => V | Promise<V>) | null
      onRejected?: ((error: any) => any) | null
    }
  }
}
